import { Stack, Typography, Unstable_Grid2 as Grid } from "@mui/material";
import styles from "./Projects.module.css";
import ProjectCard from "../ProjectCard";
import SOCademy_logo from "../../img/SOCademy_logo.png";
import zean from "../../img/zean.png";
import homeboss from "../../img/HomeBoss.png";
import locatorHackerBot from "../../img/LocatorHackerBot.png";
import teleprompter from "../../img/Teleprompter.png";
import fmPulse from "../../img/FMPulse.png";

export default function Projects() {
    return (
        <div className={styles.container} id="projects">
            <Stack 
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
            >
                <Typography variant="h4" color="rgba(255, 255, 255, 87)">Projects</Typography>
                <Grid container rowSpacing={3} columnSpacing={3} justifyContent="center">
                    <Grid display="flex" justifyContent="center">
                        <ProjectCard 
                            title="FM Pulse" 
                            description={"A web dashboard that visualises radio station playlists using data extracted from real-time stream metadata."} 
                            image={fmPulse} 
                            link={[
                                {"name": "Visit", "link": "https://fmpulse.onrender.com/"},
                            ]} 
                        />
                    </Grid>
                    <Grid display="flex" justifyContent="center">
                        <ProjectCard 
                            title="Teleprompter" 
                            description={"A web-based teleprompter that helps users present scripts smoothly with customisable settings."} 
                            image={teleprompter} 
                            link={[
                                {"name": "Visit", "link": "https://teleprompter-gilt.vercel.app/"},
                            ]} 
                        />
                    </Grid>
                    <Grid display="flex" justifyContent="center">
                        <ProjectCard 
                            title="LocatorHackerBot" 
                            description={"A Telegram bot that helps users locate the 10 nearest places of interest in their area."} 
                            image={locatorHackerBot} 
                            link={[
                                {"name": "Visit", "link": "https://devpost.com/software/locatorhackerbot"},
                            ]} 
                        />
                    </Grid>
                    <Grid display="flex" justifyContent="center">
                        <ProjectCard 
                            title="HomeBoss" 
                            description={"A desktop application used for managing deliveries targeted at home business owners. " 
                                + "\n\nDeveloped as part of Team Project for Software Engineering course."} 
                            image={homeboss} 
                            link={[
                                {"name": "Visit", "link": "https://ay2324s1-cs2103t-t13-3.github.io/tp/"},
                                {"name": "Contributions", "link": "https://ay2324s1-cs2103t-t13-3.github.io/tp/team/zhonghan721.html"}
                            ]} 
                        />
                    </Grid>
                    <Grid display="flex" justifyContent="center">
                        <ProjectCard 
                            title="Zean Chatbot" 
                            description={"A desktop chatbot that allows users to track tasks effectively. " 
                                + "It is based on Project Duke." 
                                + "\n\nDeveloped as part of Software Engineering Course Individual Project (iP)."} 
                            image={zean} 
                            link={[
                                {"name": "Visit", "link": "https://github.com/zhonghan721/ip/releases"},
                            ]} 
                        />
                    </Grid>
                    <Grid display="flex" justifyContent="center">
                        <ProjectCard 
                            title="SOCademy" 
                            description={"An all-in-one app that allows students to plan, " 
                                + "track and view their progress in NUS School of Computing.\n\n" 
                                + "Developed under NUS Orbital 2023."} 
                            image={SOCademy_logo} 
                            link={[
                                {"name": "Visit", "link": "https://socademy.vercel.app"},
                            ]} 
                        />
                    </Grid>
                    <Grid display="flex" justifyContent="center">
                        <ProjectCard 
                            title="K-rank" 
                            description={"A webpage that records some K-dramas' rankings based on my own opinion."} 
                            link={[
                                {"name": "Visit", "link": "https://tinyurl.com/k-ranks"},
                            ]} 
                        />
                    </Grid>
                </Grid>
            </Stack>
        </div>
    );
}